<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <div class="content">
      <div class="headerbg">
        <span>创新就业创业测评云平台</span>
        <b
          >CLOUD PLATFORM FOR INNOVATION, EMPLOYMENT AND <br />
          ENTREPRENEURSHIP EVALUATION</b
        >
      </div>
      <div class="list">
        <ul>
          <li>POTDPQE模型</li>
          <li>创业测评</li>
          <li>就业测评</li>
          <li>测评分析报告</li>
        </ul>
        <p>
          创就业测评云平台采用POTDPQE模型。
          为用户提供创业准备综合测评、创业潜质人才素质测评、创业人格行为特征测评、创业人才综合测评；
          职业规划测评、职业定位测评、性格气质测评、职业发展测评、职业潜能测评、职业综合素质测评、就业心理测评。
          完成职业的规划、定位、发展、潜能等全方位的测评，并对职业的测评数据进行整合与分析，打通职业规划信息与职业发展信息的孤岛。
        </p>
      </div>
      <div class="bgbox">
        <div class="setion">
          <div class="left">
            <p>创业测评</p>
            <div class="line"></div>
            <div class="text">
              从创业能力、创业时机两个方向对学员从沟通能力、领导力、创业者素质、创业心里准备等多个方面进行测评，使学员对自己的认知更加清晰，指引创业方向，降低创业失败风险。
            </div>
          </div>
          <div class="right">
            <img
              style="width: 535px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/innovationEmploymentAndEntrepreneurshipEvaluation/img1.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="bgbox">
        <div class="setion">
          <div class="right">
            <img
              style="width: 581px"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/innovationEmploymentAndEntrepreneurshipEvaluation/img2.png"
              alt=""
            />
          </div>
          <div class="left">
            <p>就业测评</p>
            <div class="line"></div>
            <div class="text">
              利用施恩职业锚测评、霍兰德职业兴趣测评、职业能力测评、人际关系综合测评等多个纬度对就业者进行考核和测评，使就业者360度全方位了解自己，对自己有更精准定位，助力于职业选择，指明发展方向。
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'innovationEmploymentAndEntrepreneurshipEvaluation',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }

}
</script>

<style lang="scss" scoped>
.setion {
  margin: 0 auto;
  display: flex;
  width: 1200px;
  padding-top: 80px;
  padding-bottom: 80px;
  // background-color: rgb(35, 135, 228);

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: start;
    p {
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .line {
      margin-top: 20px;
      width: 120px;
      height: 4px;
      background: #f39a21;
    }
    .text {
      width: 468px;
      margin-top: 60px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
       line-height: 1.8;
    }
  }
  .right {
    flex: 1;
  }
}
.bgbox {
  width: 100%;
}
.bgbox:nth-child(2n) {
  background: #f8f8f8;
  .left {
    padding-left: 140px;
  }
}
.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
  .content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    .headerbg {
      width: 100%;
      height: 580px;
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/innovationEmploymentAndEntrepreneurshipEvaluation/headerbgi.png");
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      span {
        font-size: 42px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      b {
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #006cda;
        text-align: center;
      }
    }
    .list {
      width: 100%;
      height: 243px;
      background: #f8f8f8;
    }
    .list > ul {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      li {
        list-style: none;
        height: 43px;
        text-align: center;
        width: 300px;
        border-right: 1px solid #999999;
        line-height: 43px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      li:nth-child(4) {
        border-right: none;
      }
    }
    .list p {
      margin: 0 auto;
      text-align: center;
      width: 1067px;
      margin-top: 30px;
      line-height: 1.8;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/innovationEmploymentAndEntrepreneurshipEvaluation.vue